'use client';

import { use } from 'react';

/**
 * Resolve a server-streamed number inside a Suspense island. Used for the
 * unread badges: the layout hands the count down un-awaited (the feed must not
 * gate first paint), and ONLY the badge element suspends - never a structural
 * container like the dock or a nav item, whose streamed fallback could
 * transiently coexist with the resolved copy (a duplicated landmark).
 */
export function AwaitNumber({
  value,
  children,
}: {
  value: Promise<number>;
  children: (n: number) => React.ReactNode;
}) {
  return <>{children(use(value))}</>;
}
